/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationStoreYandexGamesYandexBonusResultData } from './FxIdApplicationStoreYandexGamesYandexBonusResultData';
import {
    FxIdApplicationStoreYandexGamesYandexBonusResultDataFromJSON,
    FxIdApplicationStoreYandexGamesYandexBonusResultDataFromJSONTyped,
    FxIdApplicationStoreYandexGamesYandexBonusResultDataToJSON,
    FxIdApplicationStoreYandexGamesYandexBonusResultDataToJSONTyped,
} from './FxIdApplicationStoreYandexGamesYandexBonusResultData';

/**
 * 
 * @export
 * @interface FxIdApplicationStoreYandexGamesRedeemYandexBonusResult
 */
export interface FxIdApplicationStoreYandexGamesRedeemYandexBonusResult {
    /**
     * 
     * @type {Array<FxIdApplicationStoreYandexGamesYandexBonusResultData>}
     * @memberof FxIdApplicationStoreYandexGamesRedeemYandexBonusResult
     */
    Records: Array<FxIdApplicationStoreYandexGamesYandexBonusResultData>;
}

/**
 * Check if a given object implements the FxIdApplicationStoreYandexGamesRedeemYandexBonusResult interface.
 */
export function instanceOfFxIdApplicationStoreYandexGamesRedeemYandexBonusResult(value: object): value is FxIdApplicationStoreYandexGamesRedeemYandexBonusResult {
    if (!('Records' in value) || value['Records'] === undefined) return false;
    return true;
}

export function FxIdApplicationStoreYandexGamesRedeemYandexBonusResultFromJSON(json: any): FxIdApplicationStoreYandexGamesRedeemYandexBonusResult {
    return FxIdApplicationStoreYandexGamesRedeemYandexBonusResultFromJSONTyped(json, false);
}

export function FxIdApplicationStoreYandexGamesRedeemYandexBonusResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreYandexGamesRedeemYandexBonusResult {
    if (json == null) {
        return json;
    }
    return {
        
        'Records': ((json['Records'] as Array<any>).map(FxIdApplicationStoreYandexGamesYandexBonusResultDataFromJSON)),
    };
}

export function FxIdApplicationStoreYandexGamesRedeemYandexBonusResultToJSON(json: any): FxIdApplicationStoreYandexGamesRedeemYandexBonusResult {
    return FxIdApplicationStoreYandexGamesRedeemYandexBonusResultToJSONTyped(json, false);
}

export function FxIdApplicationStoreYandexGamesRedeemYandexBonusResultToJSONTyped(value?: FxIdApplicationStoreYandexGamesRedeemYandexBonusResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Records': ((value['Records'] as Array<any>).map(FxIdApplicationStoreYandexGamesYandexBonusResultDataToJSON)),
    };
}

